import { TType } from '../../hooks/useTranslation';
import {
  defaultRenderer,
  getBooleanColumn,
  getCrpColumns,
  getFormattedDate,
  getOptionsForTable,
  getUnitTypeValue,
  returnSingleSelectColumn,
  textColumn,
} from '../ProjectListTable/utils';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { returnNumberColumn } from '../ProjectListTable/utils';

export const getTranslatedValue = (value: any, namespace: string, t: TType) =>
  value ? t(`${namespace}.${value}`) : '';

export const getBooleanValue = (value: any, t: TType) =>
  value ? t('common.yes') : t('common.no');

export const booleanRenderer = (params: GridRenderCellParams) => {
  return params?.value;
};

const NextFyForecast = [
  'forecastLandCost',
  'forecastPropertyInvestment',
  'forecastRetailInvestment',
  'forecastRetailCost',
  'totalForecast',
  'totalReleased',
  'totalActuals',
];

const getNextForecastColumns = (t: TType) => {
  return [...NextFyForecast].map((column) => {
    return returnNumberColumn(
      t(`ppm.columns.${column.split('-')[0]}`) +
        ` ${column.split('-')[1] || ''}`,
      column,
      100,
    );
  });
};

export const returnArchiveTableColumns = (t: TType) => [
  returnSingleSelectColumn(
    'projectStatus',
    t('ppm.columns.projectStatus'),
    getOptionsForTable(t, 'statuses', true),
    'statuses',
    t,
    true,
  ),
  textColumn('referenceId', t('ppm.columns.referenceId'), 200),
  textColumn('projectName', t('ppm.columns.projectName'), 300),
  textColumn('countryName', t('ppm.columns.country'), 100),
  textColumn('city', t('ppm.columns.city'), 100),
  textColumn('mtoolId', t('ppm.columns.mtoolId'), 150),
  {
    field: 'unitType',
    headerName: t('ppm.columns.unitType'),
    aggregable: false,
    minWidth: 230,
    display: 'flex',
    type: 'singleSelect',
    valueOptions: getOptionsForTable(t, 'unitTypes', true),
    valueGetter: (params) => getUnitTypeValue(params, t),
    groupingValueGetter: (params) => getUnitTypeValue(params, t),
    renderCell: defaultRenderer,
  },
  {
    field: 'targetProjectStartDate',
    headerName: t('ppm.columns.startDate'),
    groupable: false,
    aggregable: false,
    minWidth: 150,
    display: 'flex',
    valueGetter: (value) => getFormattedDate(value),
    renderCell: defaultRenderer,
  },
  {
    field: 'targetProjectEndDate',
    headerName: t('ppm.columns.openingDate'),
    groupable: false,
    aggregable: false,
    minWidth: 150,
    display: 'flex',
    valueGetter: (value) => getFormattedDate(value),
    renderCell: defaultRenderer,
  },
  {
    field: 'lastUpdatedDate',
    headerName: 'Last Updated Date',
    groupable: false,
    aggregable: false,
    minWidth: 150,
    display: 'flex',
    valueGetter: (value) => getFormattedDate(value),
    renderCell: defaultRenderer,
  },
  ...getCrpColumns(t),
  getBooleanColumn('isep', t('ppm.columns.isep'), t),
  getBooleanColumn('partOfOnePlan', t('ppm.columns.partOfOnePlan'), t),
  getBooleanColumn('realEstateSISAN', t('ppm.columns.realEstateSISAN'), t),
  ...getNextForecastColumns(t),
];

export const DEFAULT_VIEW_COLUMNS = [
  'projectStatus',
  'id',
  'projectName',
  'countryName',
  'city',
  'projectStartDate',
  'projectCompletionDate',
  'unitType',
  'isep',
  'partOfOnePlan',
  'realEstateSISAN',
];

export const FORECAST_VIEW_COLUMNS = [
  'id',
  'projectName',
  'dpProgress',
  'isepDate',
  ...NextFyForecast,
];
